import httpService from 'src/services/app/http.service'
import { companiesService } from 'src/services/api/companies.service'
import { COMPANY_ENDPOINTS } from 'src/services/consts/api.const'
import { refactorQaSection } from 'src/services/helpers/product.helper'
import { companySectionMap } from 'src/services/consts/company.const'
import { refactorCompanyData, refactorCompanySection } from 'src/services/helpers/company.helper'

export const companyService = {
  getCompany,
  updateCompany,
  createAiAssessment,
  generateAssessmentDoc,
}

async function getCompany(companyId) {
  const res = await httpService.post(COMPANY_ENDPOINTS.GET, {
    company_id: companyId,
    info_type: 'company',
  })
  if (!res || res.error) {
    throw new Error('Company not found')
  }
  return refactorCompanyData({ ...res, companyId })
}

async function updateCompany({ companyId, sectionToUpdate, dataToUpdate }) {
  const sectionName = companySectionMap[sectionToUpdate]
  const updatedData = await httpService.post(COMPANY_ENDPOINTS.UPDATE, {
    company_id: companyId,
    section_to_update: sectionName,
    update_info: dataToUpdate,
  })

  let updatedSection = null
  if (sectionToUpdate === 'parent') {
    const companies = await companiesService.getCompanies()
    const parentCompany = companies.find((company) => company.id === dataToUpdate.parent_id)
    updatedSection = parentCompany
  } else if (sectionToUpdate === 'aiAssessment') {
    updatedSection = refactorQaSection(updatedData.company_ai_assessment_qa)
  } else {
    updatedSection = refactorCompanySection(sectionToUpdate, updatedData)
  }

  return updatedSection
}

async function createAiAssessment({ task, companyId, productId }) {
  const res = await httpService.post(COMPANY_ENDPOINTS.CREATE_AI_ASSESSMENT, {
    assessment_task: task,
    company_id: companyId,
    product_id: productId,
  })
  return res
}

async function generateAssessmentDoc({ companyId }) {
  try {
    const res = await httpService.post(COMPANY_ENDPOINTS.GENERATE_ASSESSMENT_DOC, {
      company_id: companyId,
    })

    return {
      folderLink: res.folderLink,
    }
  } catch (error) {
    // Parse error to determine if assessment is still processing
    const errorMessage = error?.response?.data?.error || error?.message || ''
    const isAssessmentProcessing = errorMessage.toLowerCase().includes('no basic assessment found')

    // Add error metadata to the error object
    error.isAssessmentProcessing = isAssessmentProcessing
    throw error
  }
}
